module.exports = __webpack_public_path__ + "img/am1.fb072a62.jpg";